import { useMemo, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector } from "react-redux";
import objectPath from "object-path";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import CustomModal from "../../../../app/components/customModal/CustomModal";
import { Button } from "@material-ui/core";
import { ExitToAppOutlined } from "@material-ui/icons";
import { useHistory } from "react-router-dom";

export function QuickUserToggler() {
  const { user } = useSelector((state) => state.user);
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      offcanvas:
        objectPath.get(uiService.config, "extras.user.layout") === "offcanvas",
    };
  }, [uiService]);

  const [modal, setModal] = useState({
    open: false,
    type: "",
  });

  const handleOpenModal = (type) =>
    setModal({
      type,
      open: true,
    });

  const handleCloseModal = () =>
    setModal({
      type: "",
      open: false,
    });

  const history = useHistory();

  const logoutClick = () => {
    const toggle = document.getElementById("kt_quick_user_toggle");
    if (toggle) {
      toggle.click();
    }
    history.push("/auth/logout");
  };
  return (
    <>
      {layoutProps.offcanvas && (
        <OverlayTrigger
          placement="right"
          overlay={
            <Tooltip id="quick-user-tooltip">مشاهده تنظیمات کاربر</Tooltip>
          }
        >
          <div
            className="topbar-item"
            onClick={() => handleOpenModal("editUser")}
          >
            <div
              className="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
              id="kt_quick_user_toggle"
            >
              <>
                {/* <span className="symbol symbol-35 symbol-light-success">
                  <span className="symbol-label font-size-h5 font-weight-bold">
                   
                  </span>
                </span> */}
                <span className="text-muted font-weight-bold font-size-base d-md-inline ml-1">
                  سلام,
                </span>
                <span className="text-dark-50 font-weight-bolder font-size-base d-md-inline mr-3">
                  {user.name}
                </span>
              </>
            </div>
          </div>
        </OverlayTrigger>
      )}
      <Button
        variant="contained"
        className="h-50 mt-4 btn-bg-gold"
        startIcon={<ExitToAppOutlined className="mr-3" />}
        onClick={logoutClick}
        // style={{backgroundColor:"#D8B063"}}
      >
        خروج
      </Button>
      {modal.open && modal.type === "editUser" && (
        <CustomModal
          route="editUser"
          type={"editUser"}
          size="sm"
          fullWidth={true}
          show={modal.open}
          closeModal={handleCloseModal}
          data={user}
          role="customer"
        />
      )}
    </>
  );
}
